
export const baseUrl = process.env.NODE_ENV === 'development' ? 'https://admin.ylcs.p695.192.168.1.193.sslip.io' : 'https://yukuaiban.cqylcsjg.com';
export const directUploadUrl = '/api/v1/direct_upload';
